/**
 * Textos da conferência final antes da assinatura (E169.F1, GUS-113 e GUS-215, ADR-0117): a versão,
 * as saídas com a marca de revisão do perito, as revisões do perito em vigor e as pendentes, e quem
 * assina. É tela da equipe; nada aqui vai ao cliente.
 */
export const ptBRConferenciaFinal = {
  eyebrow: 'Perito · conferência final',
  titulo: 'Conferir e assinar',
  subtitulo:
    'Antes de assinar, abra e revise o exame desta versão e confirme a conferência. A assinatura é feita sobre esta versão; uma versão nova pede a revisão de novo.',
  carregando: 'Lendo a conferência final…',
  erro: 'Não foi possível ler a conferência final. Tente novamente.',
  semPermissao: 'A conferência final é da equipe que atende o caso.',
  naoEncontrado: 'Caso não encontrado.',
  tentarDeNovo: 'Tentar de novo',
  voltarAoCaso: 'Voltar à mesa',
  versao: 'Versão {versao} da análise',
  semVersao: 'A análise ainda não foi gerada para este caso.',
  modo: {
    parte: 'modo PARTE',
    juizo: 'modo JUÍZO',
  },
  saidas: {
    titulo: 'Saídas desta versão',
    exame: 'Exame',
    riscos: 'Relatório de risco · reservado',
  },
  situacao: {
    nao_se_aplica: 'Não se aplica em JUÍZO',
    nao_preparada: 'Ainda não preparada',
    conferencia_pendente: 'Conferência por regras pendente',
    por_revisar: 'Por revisar',
    revisada: 'Revisado',
  },
  revisadaPor: 'Revisado por {nome} em {quando}',
  naoPreparada:
    'A prévia desta versão ainda não está pronta. O card "Preparação do pacote", na mesa, diz por quê.',
  conferenciaPendente:
    'A conferência por regras desta prévia não aprovou. Corrija na conferência do laudo antes de revisar.',
  abrir: 'Abrir a prévia',
  abrindo: 'Abrindo…',
  marcar: 'Marcar como revisado',
  marcando: 'Marcando…',
  abraAntes: 'Abra a prévia antes de marcar.',
  revisoes: {
    titulo: 'Revisões do perito nesta versão',
    nenhuma: 'Nenhuma revisão do perito registrada para o material desta versão.',
    registrada: '{codigo}{tipo} · {quem}',
    porQuem: 'registrada por {nome} em {quando}',
    semQuem: 'o registro não identifica quem revisou',
    pendentes: 'Revisões que faltam',
    tipo: {
      face: 'Comparação facial',
      autorizacao: 'Cláusula de autorização do desconto',
      suprimento: 'Suprimento',
      contraprova: 'Contraprova',
      diligencias: 'Diligências',
      credito: 'Divergência do crédito aceita com fundamento',
      integridade: 'Divergência de hash do instrumento aceita com fundamento',
    },
  },
  assinatura: {
    titulo: 'Assinatura',
    quem: 'A assinatura é do certificador da plataforma, com o certificado digital vinculado à conta.',
    voceAssina: 'Você assina este laudo com o seu certificado digital.',
    semAssinar: {
      nao_certificador:
        'Você confere e confirma; a assinatura fica com o certificador da plataforma.',
      sem_cpf: 'Cadastre o seu CPF no perfil para assinar com o certificado digital.',
    },
    segura: 'A assinatura ainda espera: {motivo}.',
    confirmo: 'Confirmo a avaliação, a conclusão e a revisão das saídas desta versão.',
    conferirEAssinar: 'Conferir e assinar',
    conferirEEnviar: 'Conferir e enviar para assinatura',
    confirmando: 'Confirmando…',
    naFila: 'Conferência confirmada: o caso aguarda a assinatura do certificador da plataforma.',
    requisicao: {
      requerida: 'Aguardando a assinatura',
      em_revisao: 'Em assinatura',
      laudo_entregue: 'Laudo assinado',
    },
  },
  // E170.F1.C04 (GUS-229, ADR-0123): a certificação entregue que não vale se revoga, sem apagar.
  revogacao: {
    titulo: 'Revogar a certificação',
    explicacao:
      'Use quando a certificação entregue não vale (por exemplo, assinada sem certificado digital). O arquivo e o histórico ficam guardados; banco e escritório perdem o acesso a esta versão; o caso volta a aguardar a assinatura e a conclusão pode ser revista.',
    motivo: 'Motivo da revogação',
    ajuda: 'Pelo menos 20 caracteres. Fica registrado com o seu nome e o horário.',
    revogar: 'Revogar a certificação',
    revogando: 'Revogando…',
    revogada: 'Certificação revogada. O caso voltou a aguardar a assinatura.',
    recusa: {
      nao_revogavel: 'Esta certificação não está entregue ou já foi revogada.',
      motivo_invalido: 'Escreva o motivo com pelo menos 20 caracteres.',
      sem_permissao: 'Só o certificador ou o responsável pela plataforma revoga a certificação.',
      indisponivel: 'Não foi possível revogar agora. Tente novamente.',
    },
  },
  recusa: {
    previa_nao_aberta: 'Abra a prévia desta versão antes de marcar como revisada.',
    previa_de_outra_versao: 'A análise mudou: abra a prévia da versão nova. A área foi atualizada.',
    previa_em_atualizacao:
      'A prévia está sendo refeita com o texto vigente. Aguarde alguns instantes e baixe de novo.',
    conferencia_nao_aprovada: 'A conferência por regras desta prévia não aprovou.',
    nao_se_aplica: 'Esta saída não se aplica ao modo do caso.',
    sem_avaliacao: 'A análise ainda não foi gerada para este caso.',
    versao_desatualizada: 'A análise mudou depois da leitura. Confira a versão nova.',
    nao_pronta: 'A assinatura ainda espera o que falta no caso.',
    fora_do_portal: 'A assinatura pela plataforma é dos casos de cliente.',
    sem_ccb: 'O caso não tem CCB a assinar.',
    indisponivel: 'Não foi possível concluir agora. Tente novamente.',
    sem_permissao: 'Você não tem acesso a esta ação.',
    nao_encontrado: 'Caso não encontrado.',
  },
} as const;
